import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../../widgets/Toolbar';
import "../../../Grid.css";
import "../../../Form.css";
import "../../../App.css";
import "./Moderator.css";
import { OnlineModeratorDetailsVerificationForm } from './OnlineModeratorDetailsVerificationForm';
import { ViewContainer } from "../../../View";
import ViewUtils from "../../../ViewUtils";
import AlertItem from "../../../widgets/AlertItem";
import withMenuPermission from "../../../widgets/withMenuPermission";


const utils = new ViewUtils();


const moderatorVerifyRef = React.createRef();
const toolbarRef = React.createRef();

const lowertoolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'back', label: 'BACK', tooltip: 'Back to uploaded documents', theme: true },
                { id: 'next', label: 'FINISH', tooltip: 'Approve Submission', theme: true }
            ]
        }
    ]
};

class OnlineModeratorDetailsVerification extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ModeratorDetails: {
                Person: {
                    FirstName: "",
                    Surname: "",
                    IDNo: ""
                }
            },
            moderatorID: null,
            notYetApproved: true
        }
        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon', visible: true }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'email', label: 'Email Moderator Letter', tooltip: 'Email Moderator Letter', disabled: true },
                        { id: 'download', label: 'Download Moderator Letter', tooltip: 'Download Moderator Letter', disabled: true }
                    ]
                }
            ]
        }
       
    };

    handleFormValueChange(values) {
        if (!utils.isNull(values)) {
            this.setState({ ModeratorDetails: values });
        }
    }

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        }
        else if ("email" === buttonId) {
            this.emailDocuments();
        }
        else if ("download" === buttonId) {
            this.generateDocuments();
        }
    }

    handleLowerToolbarButtonClick(buttonId) {
        if ("next" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineModeratorApprovalSearch',
                state: {
                    selection: this.props.location.state.selection
                }
            });
        } else if ("back" === buttonId) {
            this.props.history.push({
                pathname: '/OnlineModeratorApprovalDocuments',
                state: {
                    selection: this.props.location.state.selection
                }
            });
        }
    }

    handleToolbarButtonMenuClick(menu) {
    }

    successCallback = () => {
        this.setState({ message: "Moderator Application Updated!", messageStyle: "SUCCESS" });
    }

    save() {
        let formValue = moderatorVerifyRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            formValue.id = this.props.location.state.selection;

            let QScopeIDList = "";
            let Qselection = this.props.location.state.QualScopeSelection;
            if (Qselection !== null) {
                for (let i = 0; i < Qselection.length; i++) {
                    if (i === 0) { QScopeIDList += Qselection[i].Id; }
                    else { QScopeIDList += "," + Qselection[i].Id; }

                }
            }
            formValue.QScopeIDs = QScopeIDList;

            let USScopeIDList = "";
            let USselection = this.props.location.state.USScopeSelection;
            if (USselection !== null) {
                for (let i = 0; i < USselection.length; i++) {
                    if (i === 0) { USScopeIDList += USselection[i].Id; }
                    else { USScopeIDList += "," + USselection[i].Id; }

                }
            }
            formValue.USScopeIDs = USScopeIDList;

            let SPScopeIDList = "";
            let SPselection = this.props.location.state.SPScopeSelection;
            if (SPselection !== null) {
                for (let i = 0; i < SPselection.length; i++) {
                    if (i === 0) { SPScopeIDList += SPselection[i].Id; }
                    else { SPScopeIDList += "," + SPselection[i].Id; }

                }
            }
            formValue.SPScopeIDs = SPScopeIDList;

            let input = JSON.stringify(formValue);

            let url = "api/sims/OnlineModeratorApproval/UpdateModeratorApplication";

            utils.invokeUrl(url, (response) => {
                this.setState({ message: "Moderator Application Updated!", messageStyle: "SUCCESS", moderatorID: response.EntityId });
                toolbarRef.current.setButtonDisabled("email", false);
                toolbarRef.current.setButtonDisabled("download", false);
            },
                null,
                {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    },
                    body: input
                }
            )
        }
    };

    generateDocuments = () => {
        var moderatorFormat = [];
        moderatorFormat.push(this.state.moderatorID);

        let data = {
            ModeratorIDs: moderatorFormat,
            ...this.state.model
        }
        let url = "api/sims/OnlineModeratorApproval/GenerateModeratorLetters";
        utils.invokeUrl(url, (response) => {
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            toolbarRef.current.setButtonDisabled("download", true);
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(data)
            }
        )
    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    FileDownload = (documentName) => {

        utils.invokeUrl("api/sims/OnlineModeratorApproval/DownloadModeratorLetters?FileName=" + documentName, (response) => {

            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
            toolbarRef.current.setButtonDisabled("download", true);
        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        }
        );

    };

    emailDocuments = () => {
        var moderatorFormat = [];
        moderatorFormat.push(this.state.moderatorID);

        let data = {
            ModeratorIDs: moderatorFormat,
            ModeratorORAMID: this.props.location.state.selection,
            ...this.state.model
        }
        let url = "api/sims/OnlineModeratorApproval/GenerateAndEmailModeratorLetters";
        utils.invokeUrl(url, (response) => {
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(data)
            }
        )
    };

    render() {
       
        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {"Moderator Approval > Verify Details"}
                </p>
                <br></br>

                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <br></br>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false} title="Moderator" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    buttonMenuClickHandler={(menu) => this.handleToolbarButtonMenuClick(menu)} enabled={true} ref={toolbarRef} config={this.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "64vh", maxHeight: "64vh" }}>
                                    <OnlineModeratorDetailsVerificationForm ref={moderatorVerifyRef} id={this.props.location.state.selection} valueChangeHandler={(values) => this.handleFormValueChange(values)} editPermission = {this.props.menuPermissionItem.Edit} />
                                </div>
                            </td> 
                        </tr>
                    </tbody>
                </table>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="90%">
                            </td>
                            <td width="20%" align="right">
                                <div style={{ width: "120px", marginTop: "16px" }}>
                                    <EnhancedToolbar highlight={false} title="" buttonClickHandler={(buttonId) => this.handleLowerToolbarButtonClick(buttonId)} config={lowertoolbarConfig} />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(OnlineModeratorDetailsVerification));
